import myAxiosBackend from "@/axios";
import useToast from "@/composables/useToast";

const {success, error} = useToast();

class Api {
  // Pomocná metoda pro handling chyb
  _handleError(methodName, err, showNotification = true) {
    console.error(`Error in ${methodName}:`, err);

    if (showNotification) {
      const message = err.response?.data?.message || err.message || 'Neočekávaná chyba';
      error('Chyba API', `${methodName}: ${message}`);
    }

    throw err; // Re-throw pro další zpracování v komponentách
  }

  // Pomocná metoda pro success notifikace
  _showSuccess(message, title = 'Úspěch') {
    success(title, message);
  }

  async getPriceListItem(itemId) {
    try {
      const response = await myAxiosBackend.get(`/api/v1/price_list_item/${itemId}`);
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async allUsedMaterials(cid) {
    try {
      const response = await myAxiosBackend.get('/api/v1/all_used_materials', {params: {'calculation_id': cid}});
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async lastUsedMaterial(cid) {
    try {
      const response = await myAxiosBackend.get('/api/v1/last_used_material', {params: {'calculation_id': cid}});
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async listShapes() {
    try {
      const response = await myAxiosBackend.get('/api/v1/list_shapes');
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async listIndividualItems(cid) {
    try {
      const response = await myAxiosBackend.get('/api/v1/individual_items', {params: {cid: cid}});
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async InsertIndividualItems(payload) {
    try {
      const response = await myAxiosBackend.post('/api/v1/individual_items', payload);
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async deleteIndividualItem(item_id) {
    try {
      const response = await myAxiosBackend.delete(`/api/v1/individual_items/${item_id}`);
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async changePassword(oldPasswd, newPasswd) {
    try {
      const response = await myAxiosBackend.post('/api/v1/change_password', {
        oldPassword: oldPasswd,
        newPassword: newPasswd
      });
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async calcualteCalculation(cid, vat, cutoff) {
    try {
      const response = await myAxiosBackend.get('/api/v1/calculate_calculation_new', {
        params: {
          'cid': cid,
          'vat': vat,
          'cutoff': cutoff
        }
      });
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async changeMaterialForAllItems(cid, materialId) {
    try {
      const response = await myAxiosBackend.post('/api/v1/update_all_calculation_items_material',
        {cid: cid, material_id: materialId})
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async listPriceListItems({page, perPage, search, priceLists, materials, thicknesses, surfaces, sortBy, sortDir} = {}) {
    try {
      const response = await myAxiosBackend.get('/api/v1/list_price_list_item', {
        params: {
          page,
          per_page: perPage,
          search,
          price_lists: priceLists,
          materials,
          thicknesses,
          surfaces,
          sort_by: sortBy,
          sort_dir: sortDir,
        }
      });
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async listPriceListItemSurfaces() {
    try {
      const response = await myAxiosBackend.get('/api/v1/price_list_item_surfaces');
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async insertPriceListItem(payload) {
    try {
      const response = await myAxiosBackend.post('/api/v1/price_list_item', payload);
      this._showSuccess('Položka ceníku byla uložena', '')
      return response.data
    } catch (error) {
      this._handleError('Chyba při ukládání položky ceníku ', error, true)
    }
  }

  async updatePriceListItem(item_id, payload) {
    try {
      const response = await myAxiosBackend.patch(`/api/v1/price_list_item/${item_id}`, payload);
      this._showSuccess('Položka ceníku byla uložena', '')
      return response.data
    } catch (error) {
      this._handleError('Chyba při ukládání položky ceníku ', error, true)
    }
  }

  async deletePriceListItem(item_id) {
    try {
      const response = await myAxiosBackend.delete(`/api/v1/price_list_item/${item_id}`);
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async listPriceList() {
    try {
      const response = await myAxiosBackend.get('/api/v1/price_list_list');
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async listMaterial() {
    try {
      const response = await myAxiosBackend.get('/api/v1/material_list');
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async listThickness() {
    try {
      const response = await myAxiosBackend.get('/api/v1/thickness_list');
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async listUnits() {
    try {
      const response = await myAxiosBackend.get('/api/v1/unit_list');
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async getCalculationVersion(calculation_version_id) {
    try {
      const response = await myAxiosBackend.get(`api/v1/calculation_version/${calculation_version_id}`);
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async getCalculationVersionSettings(calculation_version_id) {
    try {
      const response = await myAxiosBackend.get(`api/v1/calculation_version/${calculation_version_id}/settings`);
      return response.data
    } catch (error) {
      console.log(error)
      return {};
    }
  }

  async listCalculationVersions(cid) {
    try {
      const response = await myAxiosBackend.get('/api/v1/calculation_versions_list', {params: {'calculation_id': cid}});
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async listPriceListIndividualItems(type, relatedTo) {
    try {
      const response = await myAxiosBackend.get('/api/v1/price_list_individual_items',
        {params: {'type': type, 'related_to': relatedTo}});
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async getCalculationNewVersion(cid) {
    try {
      const response = await myAxiosBackend.get('/api/v1/calculation_new_version', {params: {'cid': cid}});
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async calculationCalculate(settings) {
    try {
      const response = await myAxiosBackend.post('/api/v1/calculate_calculation', settings);
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async createCalculationVersion(data) {
    try {
      const response = await myAxiosBackend.post('/api/v1/calculation_version', data);
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async createPdfOffer(data) {
    try {
      const response = await myAxiosBackend.post('/api/v1/create_pdf_offer', data);
      this._showSuccess('Nová verze kalkulace byla uložena', '')
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async setCalculationStatus(cid, status) {
    try {
      const response = await myAxiosBackend.post('/api/v1/set_calculation_status', {cid: cid, status: status});
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async uploadAttachment(file, description, cid) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('description', description);
    formData.append('cid', cid);

    try {
      const response = await myAxiosBackend.post('/api/v1/attachment_upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      this._showSuccess('Soubor úspěsně uložen', '')
      return response.data
    } catch (error) {
      this._handleError('Uložení souboru', error, true)
    }
  }

  async listAttachments(cid) {
    try {
      const reponse = await myAxiosBackend.get('/api/v1/attachment_list', {params: {'cid': cid}});
      return reponse.data
    } catch (error) {
      console.log(error)
    }
  }

  async deleteAttachment(aid) {
    try {
      const response = await myAxiosBackend.delete(`/api/v1/attachment/${aid}`);
      this._showSuccess('Příloha byla smazána!', '')
      return response.data
    } catch (error) {
      this._handleError('Snmazáná přílohy ', error, true)
    }
  }

  async updateCalculationVersionDescription(versionId, description) {
    const formData = new FormData();
    formData.append('description', description);

    try {
      const response = await myAxiosBackend.patch(`/api/v1/calculation_version/${versionId}`, formData);
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async orderInsert(payload) {
    try {
      const response = await myAxiosBackend.post('/api/v1/orders', payload);
      this._showSuccess('Objednávka byla úspěšně vytvořena', '')
      return response.data
    } catch (error) {
      this._handleError('Objednávku se nepodařilo vytvořit', error, true)
    }
  }

  async orderConfirm(versionId) {
    try {
      const response = await myAxiosBackend.post(`/api/v1/orders/confirm/${versionId}`);
      this._showSuccess('Objednávka byla úspěšně potvrzena', '')
      return response.data
    } catch (error) {
      this._handleError('Objednávku se nepodařilo potvrdit', error, true)
    }
  }

  async orderUnconfirm(versionId) {
    try {
      const response = await myAxiosBackend.post(`/api/v1/orders/unconfirm/${versionId}`);
      this._showSuccess('Potvrzení objednávky bylo zrušeno', '')
      return response.data
    } catch (error) {
      this._handleError('Nepodařilo se zrušit potvrzení objednávky', error, true)
    }
  }

  async orderDelete(versionId) {
    try {
      const response = await myAxiosBackend.delete(`/api/v1/orders/${versionId}`);
      this._showSuccess('Objednávka byla smazána', '')
      return response.data
    } catch (error) {
      this._handleError('Nepodařilo se smazat objednávku', error, true)
    }
  }

  async customerListFiltered(search) {
    try {
      const reponse = await myAxiosBackend.get('/api/v1/customers', {params: {'search': search}});
      return reponse.data
    } catch (error) {
      console.log(error)
    }
  }

  async customerListPaginated(payload) {
    try {
      const reponse = await myAxiosBackend.get('/api/v1/customers/paginated',
        {
          params: {
            'page': payload.page,
            'per_page': payload.per_page,
            'search': payload.search,
            'deleted': payload.deleted
          }
        });
      return reponse.data
    } catch (error) {
      console.log(error)
      return [];
    }
  }

  async getCustomerAddresses(customerId) {
    try {
      const response = await myAxiosBackend.get(`/api/v1/customers/${customerId}/addresses`);
      return response.data;
    } catch (error) {
      console.error('Chyba při načítání adres zákazníka:', error);
      return [];
    }
  }

  async calculationListByCustomer(customerId, deleted = false) {
    try {
      const reponse = await myAxiosBackend.get('/api/v1/calculations_by_customer',
        {params: {'customer_id': customerId, deleted: deleted}});
      return reponse.data
    } catch (error) {
      console.log(error);
      return [];
    }
  }

  async orderListPaginated(payload) {
    try {
      const reponse = await myAxiosBackend.get('/api/v1/orders/paginated',
        {
          params: {
            'page': payload.page,
            'per_page': payload.per_page,
            'search': payload.search,
            'deleted': payload.deleted
          }
        });
      return reponse.data
    } catch (error) {
      console.log(error);
      return [];
    }
  }

  async aresSubjectByIco(ico) {
    try {
      const reponse = await myAxiosBackend.get(`/api/v1/ares/subject/${ico}`)
      this._showSuccess('Data z registru ARES byla načtena', '');
      return reponse.data
    } catch (error) {
      this._handleError('Nepodařilo se načíst data z registru');
      console.log(error);
      return null;
    }
  }

  async invoicesByVersionList(versionId, deleted = false) {
    try {
      const reponse = await myAxiosBackend.get(`/api/v1/invoices/version/${versionId}`,
        {params: {deleted: deleted}});
      return reponse.data
    } catch (error) {
      console.log(error);
      return [];
    }
  }

  async fakturoidInvoiceSync(invoiceId) {
    try {
      const reponse = await myAxiosBackend.get(`/api/v1/invoices/fakturoid/${invoiceId}/sync`);
      this._showSuccess('Faktura byla aktualizována', '')
      return reponse.data
    } catch (error) {
      console.log(error);
      this._handleError('Aktualizace faktury se nezdařila', error, true)
      return null;
    }
  }

  async deleteInvoice(invoiceId) {
    try {
      const reponse = await myAxiosBackend.delete(`/api/v1/invoices/${invoiceId}`);
      this._showSuccess('Faktura byla smazána', '')
      return reponse.data
    } catch (error) {
      console.log(error);
      this._handleError('Při mazání faktury došlo k chybě', error, true)
      return null;
    }
  }

  async getMaterialPrice(itemId, priceType) {
    try {
      const reponse = await myAxiosBackend.get(`/api/v1/price_list_item/${itemId}/material_price`, {params: {switch: priceType}});
      return Number(reponse.data.value ? reponse.data.value : 0)
    } catch (error) {
      console.log(error);
      this._handleError('Nepodařilo se načíst cenu', error, true)
      return null;
    }
  }

  async getCalculationHistoryLog(cid) {
    try {
      const reponse = await myAxiosBackend.get(`/api/v1/calculations/${cid}/logs`);
      return reponse.data
    } catch (error) {
      console.log(error);
      return [];
    }
  }

  async expectedDeskCount(cid, materialId, materialDetails) {
    try {
      const response = await myAxiosBackend.post(`/api/v1/expected_desk_count/${cid}/${materialId}`, materialDetails);
      return response.data
    } catch (error) {
      console.log(error);
      return 0;
    }
  }

  async getFinalInvoiceData(versionId) {
    try {
      const response = await myAxiosBackend.get(`/api/v1/invoices/version/${versionId}/final_invoice_data`);
      return response.data
    } catch (error) {
      console.log(error);
      this._handleError('Nepodařily se načíst informace pro finální fakturu', error, true)
      return null;
    }
  }

  async createFinalInvoice(versionId, payload) {
    try {
      const response = await myAxiosBackend.post(`/api/v1/invoices/version/${versionId}/final_invoice`, payload);
      this._showSuccess('Finální faktura byla úspěšně vytvořena', '')
      return response.data
    } catch (error) {
      this._handleError('Nepodařilo se vytvořit finální fakturu', error, true)
    }
  }

}

const myApi = new Api();

export default myApi;